import "chart.js/auto";
import TotalGuestDayPresenter from "./TotalGuestDayPresenter";
import BaseListPage from "../../../base/BaseListPage";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import Export from "../../../components/Export";
import printChart from "../../../PrintChart";
import DateRange from "../../../components/DateRange";
import DefaultState from "../../sales-and-transactions/components/DefaultState";
import Select from "react-select";
import InitialPrompt from "../../../components/InitialPrompt";
import GuestCountsByDayReport from "./components/GuestCountsByDayReport";
import { exportTotalGuestsPerDayCSV } from "./utils/totalGuestsPerDayCsvUtils";
import ProgressLoader from "../../../components/ProgressLoader";

class TotalGuestDayPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TotalGuestDayPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase()
    );
    this.state = {
      objects: [],
      startDate: "",
      endDate: "",
      selectedStoreCode: "",
      store: [],
      storess: "",
      range: "",
      notFound: false,
    };
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
  }

  getCollectionName() {
    return "transactions";
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) =>
      obj.store_code.replace("ANGELSPIZZA_", "")
    );

    return [...new Set(storeCodes)];
  }

  handleStartDateChange(event) {
    this.setState({ startDate: event.target.value });
  }

  handleEndDateChange(event) {
    this.setState({ endDate: event.target.value });
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  filterTransactions() {
    const { objects, startDate, endDate, selectedStoreCode } = this.state;

    return objects
      .filter((obj) => obj.status === "C")
      .filter((transaction) => {
        const transactionDate = new Date(transaction.tran_date);
        const start = startDate
          ? new Date(startDate)
          : new Date(-8640000000000000);
        const end = endDate ? new Date(endDate) : new Date();
        end.setHours(23, 59, 59, 999);
        const isDateInRange =
          (!startDate || transactionDate >= start) &&
          (!endDate || transactionDate <= end);
        const isStoreCodeMatch = selectedStoreCode
          ? transaction.store_code.replace("ANGELSPIZZA_", "") ===
            selectedStoreCode
          : true;

        return isDateInRange && isStoreCodeMatch;
      });
  }

  countTransactionTypesPerDayOfWeek = (transactions) => {
    const counts = {
      solo: new Array(7).fill(0),
      couple: new Array(7).fill(0),
      smallGroup: new Array(7).fill(0),
      meduimGroup: new Array(7).fill(0),
      largeGroup: new Array(7).fill(0),
    };

    transactions.forEach((transaction) => {
      const dayOfWeek = new Date(transaction.tran_date).getDay();
      switch (transaction.cust_count) {
        case "1":
          counts.solo[dayOfWeek]++;
          break;
        case "2":
          counts.couple[dayOfWeek]++;
          break;
        case "3":
        case "4":
        case "5":
          counts.smallGroup[dayOfWeek]++;
          break;
        case "6":
        case "7":
        case "8":
        case "9":
        case "10":
          counts.meduimGroup[dayOfWeek]++;
          break;
        case "11":
        case "12":
        case "13":
        case "14":
        case "15":
          counts.largeGroup[dayOfWeek]++;
          break;
        default:
          break;
      }
    });

    return counts;
  };

  getChartData() {
    const filteredTransactions = this.filterTransactions();
    const newCounts = this.countTransactionTypesPerDayOfWeek(
      filteredTransactions,
      new Date(this.state.startDate).getMonth(),
      new Date(this.state.startDate).getFullYear()
    );

    return {
      labels: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      datasets: [
        {
          label: "Solo",
          data: newCounts.solo,
          borderColor: "#1b74bb",
          backgroundColor: "rgba(53, 162, 235, 0.5)",
          fill: true,
        },
        {
          label: "Couple",
          data: newCounts.couple,
          borderColor: "rgb(255, 205, 86)",
          backgroundColor: "rgba(255, 205, 86, 0.5)",
          fill: true,
        },
        {
          label: "Small Group",
          data: newCounts.smallGroup,
          borderColor: "rgb(75, 192, 192)",
          backgroundColor: "rgba(75, 192, 192, 0.5)",
          fill: true,
        },
        {
          label: "Medium Group",
          data: newCounts.meduimGroup,
          borderColor: "rgb(52, 64, 84)",
          backgroundColor: "rgba(52, 64, 84,0.5)",
          fill: true,
        },
        {
          label: "Large Group",
          data: newCounts.largeGroup,
          borderColor: "rgb(208, 213, 221)",
          backgroundColor: "rgba(208, 213, 221,0.5)",
          fill: true,
        },
      ],
    };
  }

  getChartOptions() {
    return {
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            text: "Total Transactions vs Time of Day (Hours)",
          },
        },
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true,
          },
        },
      },
    };
  }

  exportToCSV = () => {
    const filtered = this.filterTransactions(this.state.objects);
    exportTotalGuestsPerDayCSV(filtered, this.state.storess || "All Stores");
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const { objects, selectedStoreCode, range, storess } = this.state;
    const chartData = this.getChartData();
    const chartOptions = this.getChartOptions();
    const chartId = "chart-container13";

    const storeOptions = [
      ...this.state.store.map((code) => ({
        value: code.name,
        label: code.name,
      })),
    ];

    const selectedOption = storeOptions.find(
      (opt) => opt.value === this.state.selectedStoreCode
    );

    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1 mt-4">
          <h2 className="fw-bold text-capitalize">
            <span style={{ color: "black" }}>Total</span>
            <span style={{ color: "#83c14a" }}> Guest</span>
            <span style={{ color: "black" }}> vs.</span>
            <span style={{ color: "#c5da55" }}> Day of Week</span>
          </h2>
          <Export
            exportCsv={this.exportToCSV}
            exportPdf={() => printChart(chartId)}
          />
        </div>
        <div className="row mb-2">
          <div className="col-sm-4" style={{ maxWidth: "max-content" }}>
            <DateRange
              onChange={this.onChangeDate.bind(this)}
              field="tran_date"
            />
          </div>
          <div className="col-sm-4">
            <Select
              options={storeOptions}
              value={selectedOption}
              onChange={(opt) => this.onChangeStore(opt.value)}
              placeholder="Select Store"
              isClearable={false}
              className="basic-single"
              classNamePrefix="select"
            />
          </div>
        </div>

        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />
        {this.state.objects && this.state.objects.length > 0 ? (
          <GuestCountsByDayReport
            chartData={chartData}
            chartOptions={chartOptions}
            storess={storess}
            range={range}
            chartRef={this.chartRef13}
            containerId="chart-container13"
          />
        ) : this.state.notFound ? (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        ) : this.state.storess && this.state.range && !this.state.notFound ? (
          <div className="text-center mt-5">
            <DefaultState />
          </div>
        ) : (
          <InitialPrompt twoFilter={true} />
        )}
      </>
    );
  }
}

export default withRouter(TotalGuestDayPage);
